/* eslint-disable max-len */
/* eslint-disable max-lines-per-function */
/**
 * @file  Board of Directors
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useContext} from 'react';
import {Divider} from 'antd';
import {BasicLayoutContext} from '~/layout/BasicLayout';

import './index.less';


function Board() {
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    return (
        <div className="board-content">
            {
                isMobile && (
                    <div className="board-content-title">
                        Board of Directors
                    </div>
                )
            }
            <div className="board-intr">
                The following members make up the Gaotu Techedu Inc. Board of Directors.
                Please select an individual member below to learn more about them and the committees they contribute to.
            </div>

            <div className="board-item">
                <div className="board-name">
                    Larry Xiangdong Chen
                </div>
                <div className="board-intro">
                    Chairman of the Board of Directors and Chief Executive Officer
                </div>
                <div className="board-story">
                    Mr. Larry Xiangdong Chen is the founder of Gaotu Techedu Inc., and has served as the chairman of the Board of Directors and the Chief Executive Officer of the Company since August 2014. Prior to founding Gaotu, Mr. Chen served as the Executive President of New Oriental Education & Technology Group Inc. (NYSE: EDU) from November 2010 to January 2014. Mr. Chen joined New Oriental in 1999. From 2001 to 2002, he served as the Executive Assistant to the Chief Executive Officer of New Oriental. From 2002 to 2003, he served as the President of the Wuhan New Oriental School. He was then promoted to Vice President, and in this role, he oversaw several departments at New Oriental’s headquarters, including Human Resources, Marketing, Public Relations, and Business Development. Mr. Chen was further promoted to Senior Vice President in January 2006. Mr. Chen received his Master’s and Ph.D. degrees in Economics from Renmin University of China, and completed the General Manager Program at Harvard Business School in 2005.
                </div>
            </div>

            <div className="board-item">
                <div className="board-name">
                    Jin Cui
                </div>
                <div className="board-intro">
                    Independent Director
                </div>
                <div className="board-story">
                    Ms. Jin Cui has served as an independent director since September 2021.
                    Ms. Cui has substantial public accounting experience, which includes serving as a partner
                    at Deloitte Beijing from 2000 to 2018 and as a partner at Zhonggongxin Certified Public
                    Accountants from 1994 to 2000, Ms. Cui was also the chief financial officer of Youshi
                    Contact Lens Co., Ltd. from 1991 to 1994,  and had seven years of experience working at
                    Zhonghua Certified Public Accountants . Ms. Cui received her bachelor’s degree in
                    Accounting from Beijing Technology and Business University. Ms. Cui is a Certified Public
                    Accountant in China and is among the first batch of senior members of the Chinese
                    Institute of Certified Public Accountants.
                </div>
                <div className="board-role">
                    <div className="board-choosed">
                        <img src="//i.gsxcdn.com/1181283949_cat1a4by.png" alt="choosed" />
                        Audit Committee
                    </div>
                    <div className="board-choose">
                        <img src="//i.gsxcdn.com/1181287269_4hclt7yn.png" alt="choose" />
                        Compensation Committee
                    </div>
                    <div className="board-choose">
                        <img src="//i.gsxcdn.com/1181287269_4hclt7yn.png" alt="choose" />
                        Nominating and Corporate Governance Committee
                    </div>
                </div>
            </div>

            <div className="board-item">
                <div className="board-name">
                    Yiming Hu
                </div>
                <div className="board-intro">
                    Independent Director
                </div>
                <div className="board-story">
                    Mr. Yiming Hu has served as an independent director since the IPO.
                    Mr. Hu has served as the chairman of the board of directors of Dongfang
                    Beidou Technology (Beijing) Co., Ltd., a provider of navigation and
                    positions products, since April 2018, and has been responsible for its
                    strategic planning, organization and implementation. From March 2006 to
                    May 2016, Mr. Hu held various positions at Ping An Trust Co., Ltd.,
                    including serving as project manager, general manager of the Beijing branch,
                    and general manager of the private wealth division. Before joining Ping An Trust,
                    Mr. Hu was a researcher at the Beijing Center for International Economic Research
                    from July 1998 to March 2006, responsible for domestic and foreign macroeconomic tracking,
                    analysis and research. Mr. Hu received his bachelor’s degree in political science and
                    law from Xinyang Normal College in 1993 and his master’s degree in international economics
                    from Renmin University of China in 1998.
                </div>
                <div className="board-role">
                    <div className="board-choose">
                        <img src="//i.gsxcdn.com/1181287269_4hclt7yn.png" alt="choose" />
                        Audit Committee
                    </div>
                    <div className="board-choosed">
                        <img src="//i.gsxcdn.com/1181283949_cat1a4by.png" alt="choosed" />
                        Compensation Committee
                    </div>
                    <div className="board-choose">
                        <img src="//i.gsxcdn.com/1181287269_4hclt7yn.png" alt="choose" />
                        Nominating and Corporate Governance Committee
                    </div>
                </div>
            </div>

            <div className="board-item">
                <div className="board-name">
                    Hao Sun
                </div>
                <div className="board-intro">
                    Independent Director
                </div>
                <div className="board-story">
                    Mr. Hao Sun has been a Tenured Associate Professor in the Gaoling School of Artificial
                    Intelligence at Renmin University of China since September 2021. Previously,
                    Mr. Sun held Tenure-Track Assistant Professor positions at the Northeastern University,
                    Boston from 2018 to 2021, and at the University of Pittsburgh from 2017 to 2018. Mr.
                    Sun received his bachelor’s degree in civil engineering from Hohai University in 2010,
                    his master’s and Ph.D. degrees in engineering mechanics from Columbia University in 2011 and 2014,
                    respectively, and completed his postdoctoral training at MIT during 2014 to 2017.
                    Mr. Sun’s research focuses on interdisciplinary AI with applications spanning science,
                    engineering, and education. Mr. Sun has authored 80 peer-reviewed publications in top-tier
                    journals such as Nature Machine Intelligence and Nature Communications,
                    as well as leading AI conferences including ICLR, NeurIPS, and KDD.
                    Mr. Sun has received multiple awards including Forbes “30 Under 30”: Science in 2018,
                    MIT Technology Review Intelligent Computing Innovator Award of China in 2022,
                    and AI100 Innovators: Young Pioneers in AI of China in 2025.
                </div>
                <div className="board-role">
                    <div className="board-choose">
                        <img src="//i.gsxcdn.com/1181287269_4hclt7yn.png" alt="choose" />
                        Audit Committee
                    </div>
                    <div className="board-choose">
                        <img src="//i.gsxcdn.com/1181287269_4hclt7yn.png" alt="choose" />

                        Compensation Committee
                    </div>
                    <div className="board-choosed">
                        <img src="//i.gsxcdn.com/1181283949_cat1a4by.png" alt="choosed" />
                        Nominating and Corporate Governance Committee
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Board;
